<template>
<div id="Activitycount" >
<v-header title="活动量管理"></v-header>
<div class="ActivitycountCon">
  <!-- <div class="menuLeft">
    <el-row class="tac">
      <el-col :span="24">
        <el-menu
          default-active="1" 
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose">
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>活动类型统计</span>
            </template>
            <el-submenu index="1-4">
              <template slot="title">选项4</template>
              <el-menu-item index="1-4-1">选项1</el-menu-item>              
            </el-submenu>
            <div class="tree" v-show="tree">
               <el-tree :data="menuDirTree" :props="defaultProps" @node-click="setDirLocation"></el-tree>
            </div>                        
          </el-submenu> 
          <el-menu-item index="1">
            <div @click="type">
              <i class="el-icon-location"></i>
              <span slot="title">活动类型统计</span>
            </div>
          </el-menu-item>      
          <el-menu-item index="2">
            <div @click="people">
              <i class="el-icon-menu"></i>
              <span slot="title">活动人次统计</span>
            </div>
          </el-menu-item>
        </el-menu>
      </el-col>
</el-row>
 </div> -->
   <!-- <div class="type" @click="type">
      <span>活动类型统计</span><i class="el-icon-arrow-right iconArrow floatRight"></i>
    </div>
    <div class="tree" v-show="tree">
    <el-tree :data="menuDirTree" :props="defaultProps" @node-click="setDirLocation"></el-tree>
    </div>
    <div class="people" @click="people">活动人次统计</div> -->
  <div class="contentRight">
    <div class="rightcon">     
      <el-row>
      <!-- <el-col :span="4" class="Navigation">
      <div class="type" @click="type">
      活动类型统计
      </div>
      <div class="tree" v-show="tree">
      <el-tree :data="menuDirTree" :props="defaultProps" @node-click="setDirLocation"></el-tree>
      </div>
      <div class="people" @click="people">活动人次统计</div>
      </el-col> -->
      <el-col :span="8" class="">
      <span>报表类型&nbsp;</span>
      <el-select v-model="value" @change="changeBranchtype(value)" >
      <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
      </el-option>
      </el-select>  
      </el-col>
      <el-col :span="8" class="">
      <span>报表时间&nbsp;</span>
      <el-date-picker
      v-model="value1"
      :type="datetype"
      :format="format"
      :editable='false'
      :clearable='false'
      @change = 'getAgentChannel()'
      :picker-options="pickerOptions0"
      placeholder="请选择报表时间"
      >
      </el-date-picker>
      </el-col>
      <el-col :span="2"  class=""><el-button  @click="excel()" class="export" >导出</el-button></el-col>
      <!-- <el-col :span='6'>
      <span>渠道</span>
      <el-select class="trench" v-model="code" @change="getAgentChannel(value)">
      <el-option
      v-for="codeitem in code"
      :key="codeitem.orderNum"
      :label="codeitem.name"
      :value="codeitem.code"
      >
      </el-option>
      </el-select>
      </el-col> -->
      <!-- <el-col :span="2" offset="6"  class=""><el-button @click="check()" class="floatRight">查询</el-button></el-col> -->
      
      </el-row>
      <el-row class="tableSubject">
        <el-col :span="18" class="" v-show="detail"><div>{{excelname}}活动量工作{{value8}}({{startDate}}至{{endDate}})</div></el-col>
      </el-row>
      <!-- <div class="tableSubject">丁敏组团队活动量工作日报表(2018-12-12至2018-12-12)</div> -->
      <el-row v-show="!tree">
        <el-col :span='24' class="nodata">暂无数据</el-col>
      </el-row>

    </div>
    <div class="rightTree" >
      <div class="tree" v-show="tree">
          <el-tree :data="menuDirTree" :props="defaultProps" @node-click="setDirLocation"></el-tree>
      </div>
    </div>
      
          
  </div>
  

</div>

</div>
</template>
<script>
import url from '@/modules/url'
import api from '@/modules/api'
import vHeader from '@/layout/Header1.vue'
export default {
  name:'Activitycount',
  components: {
    vHeader
  },
  data () {
    return {
      code: '',
      day: 1,
      tree: false,
      detail: false,
      // loading:true,
      excelcode: '',
      excelname: '',
      pickerOptions0: {
        disabledDate (time) {
          // alert(time)
          // return time.getTime() > Date.now() - 8.64e7
          return time.getTime() > Date.now()
        },
        firstDayOfWeek:1
      },
      options: [{
        value: '1',
        label: '日报表'
      }, {
        value: '2',
        label: '月报表'
      }, {
        value: '3',
        label: '周报表'
      }],
      // trenchs:[{
      //   value:'FC',
      //   label:'团险'
      // },{
      //   value:'FC',
      //   label:'个险'
      // }
      // ],
      // trenchVal:'FC',
      value: '1',
      value8: '日报表',
      endTime:'',
      // value1: new Date().setTime(new Date().getTime() - 3600 * 1000 * 24),
      value1: new Date(),
      value2: '',
      datetype: 'date',
      menuDirTree: [],
      defaultProps: {
        children: 'childGroup',
        label: 'name',
        id: 'code'
      },
      tabPosition: 'left',
      tableData: [],
      format:'',
      startDate:'',
      endDate:''
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    setDirLocation (data) {
      console.log(data.code,'111111')
      this.excelcode = data.code
      this.excelname = data.name
      console.log(this.excelcode)
      if (this.value1 != '') {
        this.detail = true
      }
    },
    // people () {
    //   this.$router.push({name: 'Activitypeople'})
    // },
    // type () {
    //   // this.tree = !this.tree
    //   this.$router.push({name: 'Activitycount'})
    // },
    excel () {
      // alert(this.excelcode)
      if(!this.tree){
          return false
      }
      if(this.value1){        
        if (this.excelcode != '') {
          // alert(this.changetime(this.value1))
          let that = this
          let options = {
            groupTeamCode: that.excelcode,
            // startDate: that.changetime(that.value1),
            startDate: that.startDate,
            flag: that.day,
            branchtype: that.code,
            // excelTitle:  that.excelname + '活动量工作' + that.value8 + '(' + that.changetime(that.value1)  + ')'
            excelTitle:  that.excelname + '活动量工作' + that.value8 + '(' + that.startDate + '至'+ that.endDate  + ')'
             
          }
          // alert(JSON.stringify(options))
          api.exportActivityGroupSummary(options, function (res) {
            if (res.result.isSuccess) {
              console.log(res)
              const elink = document.createElement('a')
              elink.download = that.excelname + '活动量工作' + that.value8 + '(' + that.startDate  + ').xls'

              elink.style.display = 'none'
              elink.href = res.data.loadUrl // URL.createObjectURL(blob)
              document.body.appendChild(elink)
              elink.click()
              // URL.revokeObjectURL(blob)
              document.body.removeChild(elink)
            }
            console.log(res)
          })
        } else {          
          alert('请选择团队')
        }
      }else{
        alert('请选择报表时间')
      }
      
    },
    changetime (data) {
      let getDate = new Date(data)
      let y = getDate.getFullYear()
      let M = getDate.getMonth() + 1
      let d = getDate.getDate()
      let format = y + '-' + M + '-' + d
      return format
    },
    // check () {
    //   this.getAgentChannel()
    // },
    getAgentChannel () {
      let that = this      
      api.getAgentChannel({}, function (res) {
        if (res.result.isSuccess === true) {
          that.code = res.data[0].code
          console.log(1)
          console.log(that.code)
          that.getActivityGroupTree()
        }
      })
    },
    getActivityGroupTree () {
      let that = this
      if(that.value8=='日报表')
      {
        that.startDate = that.changetime(that.value1)
        that.endDate = that.changetime(that.value1)
      }
      if(that.value8=='周报表')
      {
        that.startDate = that.changetime(that.value1.getTime()-24*60*60*1000)
        that.endDate = that.changetime(that.value1.getTime()+24*60*60*1000*5)
      }
      if(that.value8=='月报表')
      {
        that.startDate = that.changetime(that.value1)
        // alert(that.value1)
        let Vyear = that.value1.getFullYear()
        let Vmonth = that.value1.getMonth() + 1
        let lastDay = new Date(Vyear,Vmonth,0)        
        that.endDate = that.changetime(lastDay)
        // alert(that.endDate)
      }
      const loading = that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let options = {
        // startDate: that.changetime(that.value1),
        startDate: that.startDate,
        flag: that.day,
        branchtype: that.code
      }
      // alert(JSON.stringify(options))
      api.getActivityGroupTree(options, function (res) {
        console.log(res,"树")
        // loading.close()
        if (res.result.isSuccess) {
          that.menuDirTree = res.data          
          that.tree = true
          document.querySelector('.export').classList.remove('is-disabled')
          loading.close()
          // console.log(JSON.stringify(that.menuDirTree))
        } else {
          that.menuDirTree = []
          that.excelcode = ''
          that.detail = false
          that.tree = false
          // document.querySelector('.export').setAttribute('disabled', 'true')
          document.querySelector('.export').classList.add('is-disabled')  
          loading.close()
          // alert('抱歉,暂无数据')
        }
      })
    },
    changeBranchtype (value) {
      // alert(value)
      if (value === '1') {
        this.value1 = ""
        this.datetype = 'date'
        this.format = ''
        this.day = 1
        this.detail = false
        this.menuDirTree = []
        this.excelcode = ''
        this.tree = false
        document.querySelector('.export').classList.add('is-disabled') 
        // this.value1 = new Date().setTime(new Date().getTime() - 3600 * 1000 * 24)
        // this.value1 = new Date()
        this.value8 = '日报表'
      }
      if (value === '2') {
        this.datetype = 'month'
        this.format = ''
        this.day = 2
        this.value1 = ""
        this.detail = false
        this.menuDirTree = []
        this.excelcode = ''
        this.tree = false
        document.querySelector('.export').classList.add('is-disabled') 
        // let temp = new Date()
        // this.value1 = new Date()
        this.value8 = '月报表'
      }
      if (value === '3') {        
        // this.value1 = new Date()
        this.value1 = ""
        this.format = 'yyyy 第 WW 周'
        this.datetype = 'week'
        this.day = 3
        this.detail = false
        this.menuDirTree = []
        this.excelcode = ''
        this.tree = false
        document.querySelector('.export').classList.add('is-disabled') 
        this.value8 = '周报表'
      }
      // alert(this.value1)
    }
  },
  mounted () {
    this.getAgentChannel()
  }
}
</script>

<style scoped>
/* .Navigation{
  color: #9D9D9D;
  height: 100vh;
} */
.body{
    font-family:"Microsoft YaHei";
    font-size: 19px;
    /* background: #fff; */
    width:100%;
    min-height: 100%;
    /* overflow-x: hidden; */
}
/* #Activity{
  height: 100%;
} */
#Activitycount{
  /* padding-top: 60px; */
  height: 100%;
  box-sizing: border-box;
}
.ActivitycountCon{
  overflow: hidden;
  /* min-height: 100%; */
  height:100%;
  box-sizing: border-box;
  padding-top: 20px;
  -webkit-box-sizing: border-box;
}
.menuLeft{
  width:14%;
  float: left;
  height: 100%;
  background: #ffffff;
}
.contentRight{
  width:100%;
  float: left;
  /* padding-top: 20px; */
  position: relative;
  min-height: 100%;
}
.rightTree{
  width: 20%;
  height: 100%;
  position: absolute;
  left: 51%;
  top: 100px;
  
}
.rightcon{
  width: 96%;
  margin: 0 auto;
}
.tableCon{
  margin-top: 20px;
}

#Activitycount >>> .el-menu{
  border-right: 0;
}
.tableSubject{ 
  font-size: 18px; 
  /* text-align: center; */
  padding-top: 30px;
  /* font-weight: bold; */
  line-height: 24px;
}
.tree >>> .el-tree{
  background: transparent;
}
.tree >>> .el-tree-node__label{
  font-size:16px;
}
.tree >>> .el-tree-node__content{
  height: 30px;
}
.type,.tree,.people{
  width: 100%;
  /* text-align: center; */
  padding:0 20px;
  box-sizing: border-box;
}
.type{
  margin-top: 20px;
  height: 35px;
  line-height: 35px;
  color:#3D62AD
}
.people{
  margin-top: 10px;
  height: 35px;
  line-height: 35px;
}
.tree{
  /* padding-top: 10px; */
  height: 100%;
  border-left: 1px solid #eee;
}
/*.iconArrow{
  height: 35px;
  line-height: 35px;
} */
.tree >>> .el-tree__empty-block{
min-height:46px;
}

.userinfo{ width: 94%;margin: 0 auto;background: #fff; margin-top:2%;}
.item{
    width: 88%;
    height: auto;
    margin: 0 auto;
    line-height: 53px;
    border-bottom: 1px solid #f5f5f5;
    overflow: hidden;
}
.item.arrow{ position:relative;}
.item.arrow i{color:#D4D4D4; position:absolute; right:10px; top:50%; margin-top:-9px; cursor:pointer;}
.item.arrow span{color: #3D62AD;cursor:pointer;}
.line{
    line-height: 33px;
}
.photo{
    width:30%;
    float: left;
}
.photo img {
    float: right;
}
.info{
    width:70%;
    float: left;
}
label{
    float: left;
    display: block;
    width: 31%;
    color: #919191;
}

.userinfo span{
    float: left;
    display: block;
    width: 69%;
}
.el-col {
    border-radius: 4px;
}
.grid-content {
    border-radius: 4px;
    padding-top: 40px;
    min-height: 75vh;
}
/* .Navigation{
  height: 93vh;
  background: #fff
} */
/* .type,.tree,.people{
  width: 100%;
  text-align: center;
  padding:0 20px;
  box-sizing: border-box;
}
.type,.people{
  margin-top: 20px
}
.type{
  color:#3D62AD
} */
.trench{
  width: 100px;
}
/* .export{
  margin-top: 20px;
} */
.is-opened{
  background-color: #ecf5ff;
}
.is-opened .el-submenu__title{
  color: #409EFF;
}
/* .el-menu-item.is-active{
  color: #666;
  background: inherit;
}
.el-menu-item:focus, .el-menu-item:hover{
  background-color:inherit;
} */
.nodata{
  color: #666;margin-top: 20px; text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/Activitycount/Activitycount.vue